export * from "./types.js";
export * from "./copy.js";
export {
  calculateCcsBuffer,
  assertNoProductHandoff,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { CcsBufferRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of ccs-buffer rulesets by financial year. Historical years stay
 * registered so re-runs resolve against the withholding constants + the au13
 * income taper in force then. */
export const CCS_BUFFER_RULESETS: Record<string, CcsBufferRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the ccs-buffer ruleset for a financial year, or throw if unknown. */
export function ccsBufferRulesFor(fy: FinancialYear): CcsBufferRuleSet {
  const rules = CCS_BUFFER_RULESETS[fy];
  if (!rules) {
    throw new Error(`no ccs-buffer ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent ccs-buffer ruleset — the default for live "this year" calcs. */
export const CCS_BUFFER_CURRENT_FY: FinancialYear = "2025-26";
